export function compare(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}

export function getFileName(response) {
    const contentDisposition = response.headers['content-disposition'];
    return contentDisposition.substr(contentDisposition.indexOf('filename=') + 9);
}


export function printDiv(ifId, divClassName) {
    const content = document.getElementsByClassName(divClassName)[0];
    const pri = document.getElementById(ifId).contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
}

export function validateDecimal(str) {
    const re = /^(\d+\.?\d{0,9}|\.\d{1,9})$/;
    return re.test(str)
}


// WEBPACK FOOTER //
// ./src/utils/utils.js